import { useMemo } from 'react';
import { ResponsiveContainer } from 'recharts';
import { useFinancialsStore } from '../../../store/financials-store/financials-store';
import { Charts as ChartsType } from '../../../store/financials-store/financials-store.type';
import { Chart as AllocationOfCostsChart } from './allocation-of-costs/chart';
import { Chart as CostByInitiativeChart } from './cost-by-initiative/chart';
import { Chart as CostVersusOutputChart } from './cost-versus-output/chart';

function Charts() {
  const selectedChart = useFinancialsStore((state) => state.chart);

  const chart = useMemo(() => {
    switch (selectedChart) {
      case ChartsType.CostVersusOutput:
        return <CostVersusOutputChart />;
      case ChartsType.AllocationOfCosts:
        return <AllocationOfCostsChart />;
      default:
        return <CostByInitiativeChart />;
    }
  }, [selectedChart]);

  return (
    <ResponsiveContainer width="100%" height={'90%'}>
      {chart}
    </ResponsiveContainer>
  );
}

export { Charts };
